module.exports = __webpack_public_path__ + "static/img/Coby-Black.a4d430d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coby-Black.jpg
// module id = LrbN
// module chunks = 0